import React from 'react'
import { Grid } from '../../../common/grid/Grid'
import { Divider, makeStyles, Text, tokens } from '@fluentui/react-components'
import { GridItem } from '../../../common/grid/GridItem'
import { RiskAssessmentBadge } from '../../RiskBadges'
import { RiskStatus } from '../../../../api/schemas/schema'
import { t } from 'i18next'
const useStyles = makeStyles({
   badge: {
      minWidth: '150px',
      minHeight: '40px',
      fontSize: tokens.fontSizeBase300,
   },
   textStyling: {
      marginLeft: tokens.spacingHorizontalL,
      '@media screen and (max-width: 1007px)': {
         marginLeft: 0,
         marginTop: tokens.spacingVerticalMNudge,
      },
   },
   phoneColumn: {
      '@media screen and (max-width: 1007px)': {
         '& > *': {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
         },
      },
   },
})

export const SimplifiedRiskCriteria = () => {
   const classes = useStyles()

   return (
      <Grid className={classes.phoneColumn}>
         <GridItem size="12/12">
            <Divider appearance="brand" />
         </GridItem>

         <GridItem size="12/12">
            <RiskAssessmentBadge status={RiskStatus.Unacceptable} className={classes.badge} />
            <Text size={400} className={classes.textStyling}>
               {t('BigRiskShouldBeAddressed')}
            </Text>
         </GridItem>

         <GridItem size="12/12">
            <RiskAssessmentBadge status={RiskStatus.Questionable} className={classes.badge} />
            <Text size={400} className={classes.textStyling}>
               {t('UncertaintyAboutRiskShouldBeAddressed')}
            </Text>
         </GridItem>

         <GridItem size="12/12">
            <RiskAssessmentBadge status={RiskStatus.Acceptable} className={classes.badge} />
            <Text size={400} className={classes.textStyling}>
               {t('SmallRiskShouldNotBeAddressed')}
            </Text>
         </GridItem>
      </Grid>
   )
}
